export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP////8AAOXl5QAAACH5BAAAAAAALAAAAAASAAwAAAIilI+JwO0PDJxNvoADtC3nxzEeBgrXWJ5eqmostZlwrNRIAQA7"